<div class="d-flex flex-column align-items-center">
    <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
        <h5>Upload Candidates Passport</h5>
        <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="uploadPassports()">

            <div class="mb-3 mr-0 col-md-10">
                <label class="form-label">Select Compressed File (.zip,.rar,.7zip)*</label>
                <input type="file" class="form-control file-select" accept=".zip,.rar,.7zip"
                    (change)="onFileChange($event)">
            </div>
            <div class="mb-3 mr-0 col-md-10">
                <label class="form-label">Special Characters Replaced With Underscore('_'). (If Multiple Characters Are
                    Present, Put It In order of replacement)</label>
                <input class="form-control" type="text" [(ngModel)]="uploadCand.specialCharacters"
                    name="specialCharacters" />
            </div>
            <div class="mb-3 mr-0 col-md-10">
                <div class="row">
                    <div class="col-md-6">
                        <div class="">
                            <label class="form-label">Image-name-prefix</label>
                            <input class="form-control" type="text" [(ngModel)]="uploadCand.imagePrefix"
                                name="imagePrefix" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="">
                            <label class="form-label">Image-name-suffix</label>
                            <input class="form-control" type="text" [(ngModel)]="uploadCand.imageSuffix"
                                name="imageSuffix" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb-3 mr-0 col-md-10">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" [(ngModel)]="uploadCand.skipErrors"
                                name="skipErrors">
                            <label class="form-check-label" for="flexCheckDefault">
                                Skip Errors
                            </label>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox"
                                [(ngModel)]="uploadCand.overridePreviousValues" name="overridePreviousValues">
                            <label class="form-check-label" for="flexCheckDefault">
                                Override Previous Values
                            </label>
                        </div>
                    </div>

                </div>
            </div>


            <button class="btn btn-primary btn-lg col-md-10" type="submit" [disabled]="!uploadCand.imageFile"> Upload
            </button>
        </form>
    </div>
</div>